import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/new',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TeamNewContainer',
      './modules/teamNew'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const TeamNew = require('./containers/TeamNewContainer').default
      const actions = require('./modules/teamNew')
      const reducer = require('./modules/teamNew').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'teamNew', reducer: reducer })

      store.dispatch(actions.initialize())
      /*  Return getComponent   */
      cb(null, TeamNew)

    /* Webpack named bundle   */
    }, 'teamNew')
  }
})



// WEBPACK FOOTER //
// ./src/routes/TeamNew/index.js